import { Languages } from './languages';

export enum MainKeywordEnum {
    BANKRUPTCY_LAW = 'BANKRUPTCY_LAW',
    BUSINESS_CONTRACTS = 'BUSINESS_CONTRACTS',
    COMMERCIAL_LEASES = 'COMMERCIAL_LEASES',
    COMPETITION = 'COMPETITION',
    COMPLIANCE = 'COMPLIANCE',
    CONSUMPTION = 'CONSUMPTION',
    CORPORATE_CRIMINAL_LIABILITY = 'CORPORATE_CRIMINAL_LIABILITY',
    CORPORATE_LAW = 'CORPORATE_LAW',
    DISTRIBUTION = 'DISTRIBUTION',
    DIGITAL_AI = 'DIGITAL_AI',
    EU_BUSINESS_LAW = 'EU_BUSINESS_LAW',
    INDUSTRIAL_PROPERTY_LAW = 'INDUSTRIAL_PROPERTY_LAW',
    PROCEDURAL_LAW = 'PROCEDURAL_LAW',
}

/** Stable stored values; display labels and translations are defined separately below. */
export enum CompetitionSubcategoryEnum {
    GENERAL = 'Généralités',
    COMPETITION_PROCEDURE = 'Procédure de la concurrence',
    ANTICOMPETITIVE_AGREEMENTS = 'Ententes',
    ABUSE_OF_DOMINANCE = 'Abus de domination',
    MERGERS = 'Concentrations',
    STATE_AID = "Aides d'Etat",
    UNFAIR_PRACTICES = 'Pratiques déloyales',
    UNFAIR_COMPETITION = 'Concurrence déloyale',
}

export const competitionSubcategoryLabels: Record<
    Languages,
    Record<CompetitionSubcategoryEnum, string>
> = {
    fr: {
        [CompetitionSubcategoryEnum.GENERAL]: 'Généralités',
        [CompetitionSubcategoryEnum.COMPETITION_PROCEDURE]: 'Procédure de la concurrence',
        [CompetitionSubcategoryEnum.ANTICOMPETITIVE_AGREEMENTS]: 'Ententes',
        [CompetitionSubcategoryEnum.ABUSE_OF_DOMINANCE]: 'Abus de domination',
        [CompetitionSubcategoryEnum.MERGERS]: 'Concentrations',
        [CompetitionSubcategoryEnum.STATE_AID]: 'Aides d’État',
        [CompetitionSubcategoryEnum.UNFAIR_PRACTICES]: 'Pratiques déloyales',
        [CompetitionSubcategoryEnum.UNFAIR_COMPETITION]: 'Concurrence déloyale',
    },
    en: {
        [CompetitionSubcategoryEnum.GENERAL]: 'General',
        [CompetitionSubcategoryEnum.COMPETITION_PROCEDURE]: 'Competition Procedure',
        [CompetitionSubcategoryEnum.ANTICOMPETITIVE_AGREEMENTS]: 'Anticompetitive Agreements',
        [CompetitionSubcategoryEnum.ABUSE_OF_DOMINANCE]: 'Abuse of Dominance',
        [CompetitionSubcategoryEnum.MERGERS]: 'Mergers',
        [CompetitionSubcategoryEnum.STATE_AID]: 'State Aid',
        [CompetitionSubcategoryEnum.UNFAIR_PRACTICES]: 'Unfair Practices',
        [CompetitionSubcategoryEnum.UNFAIR_COMPETITION]: 'Unfair Competition',
    },
};

export const competitionSubcategories = Object.values(CompetitionSubcategoryEnum);

export const isCompetitionSubcategory = (value: unknown): value is CompetitionSubcategoryEnum =>
    typeof value === 'string' &&
    competitionSubcategories.some((subcategory) => subcategory === value);

export const competitionSubcategoryOptions = competitionSubcategories.map((value) => ({
    value,
    label: competitionSubcategoryLabels.fr[value],
}));

export const mainKeywordLabels: Record<Languages, Record<MainKeywordEnum, string>> = {
    fr: {
        DIGITAL_AI: 'Numérique / IA',
        BANKRUPTCY_LAW: 'Procédures collectives',
        BUSINESS_CONTRACTS: 'Contrats d’affaires',
        COMMERCIAL_LEASES: 'Baux commerciaux',
        COMPETITION: 'Droit de la concurrence',
        COMPLIANCE: 'Droit de la compliance',
        CONSUMPTION: 'Droit de la consommation',
        CORPORATE_CRIMINAL_LIABILITY: 'Droit pénal des affaires',
        CORPORATE_LAW: 'Droit des sociétés',
        DISTRIBUTION: 'Droit de la distribution',
        EU_BUSINESS_LAW: 'Droit européen des affaires',
        INDUSTRIAL_PROPERTY_LAW: 'Propriété industrielle',
        PROCEDURAL_LAW: 'Droit processuel',
    },
    en: {
        DIGITAL_AI: 'Digital / AI',
        BANKRUPTCY_LAW: 'Bankruptcy Law',
        BUSINESS_CONTRACTS: 'Business Contracts',
        COMMERCIAL_LEASES: 'Commercial Leases',
        COMPETITION: 'Competition Law',
        COMPLIANCE: 'Compliance',
        CONSUMPTION: 'Consumer Law',
        CORPORATE_CRIMINAL_LIABILITY: 'Corporate Criminal Liability',
        CORPORATE_LAW: 'Corporate Law',
        DISTRIBUTION: 'Distribution Law',
        EU_BUSINESS_LAW: 'EU Business Law',
        INDUSTRIAL_PROPERTY_LAW: 'Industrial Property Law',
        PROCEDURAL_LAW: 'Procedural Law',
    },
};

export const mainKeywordNameValue = Object.values(MainKeywordEnum).map((value) => ({
    value,
    label: mainKeywordLabels.fr[value],
}));

export const mainKeywordNameValueMap = new Map<MainKeywordEnum | null, string>(
    mainKeywordNameValue.map(({ value, label }) => [value, label]),
);
